import { FC } from "react";
import { makeStyles } from "tss-react/mui";
import { MiWorkOrderCard } from "@miplatform/components";
import { IAttemptListItemResponseForWorkOrder } from "@miplatform/types";
import { Box } from "@mui/material";

const CARD_HEIGHT = 60;

const UnassignedWorkOrderCardItem: FC<{
  workOrder: IAttemptListItemResponseForWorkOrder;
  loading: boolean;
  onWorkOrderClick?: (attempt: IAttemptListItemResponseForWorkOrder) => void;
  zoom?: number;
}> = ({ workOrder, loading, onWorkOrderClick, zoom = 1 }) => {
  const { classes } = useStyles({ cardHeight: zoom * CARD_HEIGHT });
  return (
    <Box
      role="button"
      tabIndex={0}
      className={classes.cardWrap}
      onClick={() => onWorkOrderClick?.(workOrder)}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          onWorkOrderClick?.(workOrder);
        }
      }}
    >
      <MiWorkOrderCard attempt={workOrder} loading={loading} />
    </Box>
  );
};

export const UnassignedWorkOrdersList: FC<UnassignedWorkOrdersListProps> = ({
  workOrders,
  loading,
  onWorkOrderClick,
  zoom = 1,
}) => {
  const { classes } = useStyles({ cardHeight: zoom * CARD_HEIGHT });

  return (
    <Box className={classes.list}>
      {workOrders.map((workOrder) => (
        <UnassignedWorkOrderCardItem
          key={workOrder.id}
          workOrder={workOrder}
          loading={loading}
          onWorkOrderClick={onWorkOrderClick}
          zoom={zoom}
        />
      ))}
    </Box>
  );
};

type UnassignedWorkOrdersListProps = {
  workOrders: IAttemptListItemResponseForWorkOrder[];
  loading: boolean;
  onWorkOrderClick?: (attempt: IAttemptListItemResponseForWorkOrder) => void;
  zoom?: number;
};

const useStyles = makeStyles<{ cardHeight: number }>()(
  (theme, { cardHeight }) => ({
    list: {
      display: "flex",
      flexWrap: "wrap",
      alignContent: "flex-start",
      gap: theme.spacing(1),
      overflow: "auto",
      padding: theme.spacing(1.5),
    },
    cardWrap: {
      display: "flex",
      height: `${cardHeight}px`,
      justifyContent: "center",
      alignItems: "center",
      cursor: "pointer",
    },
  })
);
